import { useCallback } from 'react';
import { SubmitHandler } from 'react-hook-form';

import { EditUserFormValuesT } from '../declarations';
import { useUserProfile } from 'contexts/UserProfileContext';
import usePushNotifications from 'hooks/common/usePushNotifications';

type useProfilePageT = {
  handleSubmitForm: SubmitHandler<EditUserFormValuesT>;
  handleDeleteImgBtnClick: () => void;
};

const useProfilePage = (): useProfilePageT => {
  /**
   * Hooks
   */
  const { updateUser, deleteUserPhoto } = useUserProfile();
  usePushNotifications();

  /**
   * Handlers
   */
  const handleDeleteImgBtnClick = () => {
    deleteUserPhoto();
  };

  const handleSubmitForm = useCallback(
    (userData: EditUserFormValuesT) => {
      updateUser(userData);
    },
    [updateUser]
  );

  return {
    handleSubmitForm,
    handleDeleteImgBtnClick,
  };
};

export default useProfilePage;
